// extracted by mini-css-extract-plugin
module.exports = {"expandListButton":"AccordionButton_expandListButton__1oka0","expandIcon":"AccordionButton_expandIcon__2MlAV","expanded":"AccordionButton_expanded__11FVh"};